import {Injectable} from "@angular/core";

export const USER_KEY = 'auth-user';
export const TEMP_EMAIL = 'temp-email'
export const TOKEN_KEY = 'accessToken';
export const AZURE_TOKEN_KEY = 'cb.account.accessToken';
export const USER_ID = 'cb.account.uid';


@Injectable({
  providedIn: 'root'
})
export class LocalStorageUtils {

  static setInfo(keyName: string, value: any): void {
    window.localStorage.removeItem(keyName);
    window.localStorage.setItem(keyName, btoa(JSON.stringify(value)));
  }

  static setAccessToken(keyName: string, value: any): void {
    window.localStorage.removeItem(keyName);
    window.localStorage.setItem(keyName, value);
  }

  static getAccessToken(keyName: string): string | null {
    return window.localStorage.getItem(keyName);
  }

  static getInfo(keyName: string): any {
    try {
      const userDetails = window.localStorage.getItem(keyName);
      if (userDetails) {
        return JSON.parse(atob(userDetails));
      }
    } catch {
      return null;
    }
  }

  static removeInfo(keyName: string): void {
    window.localStorage.removeItem(keyName);
  }

  static getCurrentUserInfo(): any {
    return this.getInfo(USER_KEY);
  }

  static setSessionStorageInfo(keyName: string, value: string): void {
    window.sessionStorage.removeItem(keyName);
    window.sessionStorage.setItem(keyName, btoa(JSON.stringify(value)));
  }

  static getSessionStorageInfo(keyName: string): any {
    try {
      const info: string | null = window.sessionStorage.getItem(keyName);
      if (info) {
        return JSON.parse(atob(info));
      }
    } catch {
      return null;
    }
  }

  static removeSessionStorageInfo(keyName: string): void {
    window.sessionStorage.removeItem(keyName);
  }
}
